<template>
  <div class="mx-auto p-3 mb-4 border">
    <p>
      Eine paysafecard erhälst du Beispielweise an vielen Tankstellen,
      Einkaufsläden und Ähnlichem. Verkaufsstellen suchen:
      <a href="https://www.paysafecard.com/pos">www.paysafecard.com/pos</a>
    </p>
    <ul>
      <li>Kaufe eine paysafecard mit einer 16-stelligen PIN</li>
      <li>Gebe hier den 16-stelligen PIN einfach ein</li>
      <li>
        Schon hast du bezahlt, ohne Kreditkarte und Bankverbindung, völlig
        anonym.
      </li>
    </ul>
    <p>
      Pro Bezahlvorgang kannst du bis zu 100 EUR ausgeben. Mehr Infos findest du
      unter <a href="https://www.paysafecard.com">www.paysafecard.com</a>.
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    appCurrency() {
      return Laravel.lang.currency;
    }
  }
};
</script>
